import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Icon, Modal, Grid, Input, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {getDropdownOptions} from '../../../../common/util/dropdown';
import {isString} from 'lodash';

const {
  changeWtsSkillSelected,
  createWtsSkill,
  updateWtsSkill,
} = Actions;

const WtsSkillsModal = ({mode, skillToEdit}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const wtsCoursesAreas = useSelector((state) => state.wtsCoursesAreas.coursesAreas);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);
  const skillSelected = useSelector((state) => state.wtsSkills.skillSelected);
  
  const onChangeValues = (value, field) => {
    const changedSkillSelected = {...skillSelected, [field]: isString(value) ? value.toUpperCase() : value};
    dispatch(changeWtsSkillSelected(changedSkillSelected));
  };

  const showCourseStatusModal = (e, value) => {
    e.preventDefault();
    setShowModal(value);
    if (mode === 'edit') {
      dispatch(changeWtsSkillSelected(skillToEdit));
    } else {
      dispatch(changeWtsSkillSelected({'course_area': '', 'description': '', 'status': 'A'}));
    }
  };

  const saveCourseArea = (e) => {
    e.preventDefault();
    if (mode === 'new') {
      dispatch(createWtsSkill(areaSelected.id, {'data': skillSelected}));
    } else {
      dispatch(updateWtsSkill(areaSelected.id, {'data': skillSelected}));
    }
    showCourseStatusModal(e, false);
  };

  return (
    <Modal size='tiny' closeOnEscape={false} closeOnDimmerClick={false}
      open={showModal}
      trigger={
        mode === 'new' ?
          <Button compact content="Añadir"
            icon={<Icon name='add-circle' size='big' color='green' />}
            onClick={(e) => showCourseStatusModal(e, true)} /> :
          <Icon link name='pencil' size='big' onClick={(e) => showCourseStatusModal(e, true)} color='green' />
      }>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            {mode === 'new' ? 'Crear Habilidad' : 'Editar Habilidad'}
          </h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showCourseStatusModal(e, false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid stackable stretched>
          <Grid.Row>
            <Grid.Column>
              <div className="ui labeled input fluid">
                <div className="ui label" style={{'display': 'flex', 'alignItems': 'center'}}>Área</div>
                <Dropdown fluid selection
                  placeholder='Selecciona área'
                  value={skillSelected?.course_area || ''}
                  onChange={(e, i) => onChangeValues(i.value, 'course_area')}
                  options={getDropdownOptions(wtsCoursesAreas, 'id', 'course_area') || []}
                  style={{'borderTopLeftRadius': 0, 'borderBottomLeftRadius': 0}}
                />
              </div>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Habilidad"
                value={skillSelected?.description || ''}
                onChange={(e, {value}) => onChangeValues(value, 'description')}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button positive compact icon='save' onClick={(e) => saveCourseArea(e)}>Guardar</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WtsSkillsModal;
